export const articleIntroductionMobileTextLength = 85;
export const articleIntroductionDesktopTextLength = 120;
